import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@common/Icon/Icon";
import { DATE_FORMAT, EORDER_STATUS, EORDER_TYPE } from "@constants";
import "./css/OrderItemList.scss";
import { IOrder, IOrderOffer } from "./interface/IOrder";
import { format } from "date-fns";

interface IParams {
    offerList: IOrderOffer[];
    order: IOrder;
}

export const OrderItemList = (props: IParams) => {
    const [isOpen, setIsOpen] = useState(false);
    const { offerList, order } = props;
    const { t } = useTranslation(["order", "common"]);

    const arrowPosition = isOpen ? "up" : "down";
    const orderedOn = format(new Date(order.createdDateTime), DATE_FORMAT);

    const orderTitle = EORDER_TYPE[order.orderType];
    const orderTitleText = t(`order:${orderTitle}`);

    return (
        <div className="order-card">
            <Grid alignItems="center" className="order-card-wrapper" container spacing={1}>
                <Grid item xs="auto">
                    <Typography color="secondary" gutterBottom variant="h4">
                        {orderTitleText}
                    </Typography>
                    <Typography color="secondary" variant="body1">
                        {t("order:orderedOn")} {orderedOn}
                    </Typography>
                    <Typography color="secondary" gutterBottom variant="body1">
                        {t("order:orderId", { id: order.reference })}
                    </Typography>
                </Grid>
                <Grid item xs="auto">
                    <Grid alignItems="center" container direction="column">
                        <Chip
                            className={`order-card-wrapper__chip ${order.status.toLowerCase()}`}
                            label={t(`order:${EORDER_STATUS[order.status]}` as any)}
                        />
                    </Grid>
                </Grid>
                {isOpen && (
                    <Fragment>
                        <Hidden xsDown>
                            <Grid item xs={12}>
                                <Typography align="right" color="secondary" variant="body1">
                                    {t("order:onceOffCharge")}
                                </Typography>
                            </Grid>
                        </Hidden>
                        {offerList.map((offer: IOrderOffer, index: number) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Fragment key={index}>
                                <Grid item xs={12}>
                                    <Grid alignItems="center" className="order-card__description" container>
                                        <Grid item sm={9} xs={12}>
                                            <Typography color="secondary" variant="h5">
                                                {offer.name}
                                            </Typography>
                                            <Typography color="secondary" variant="body1">
                                                {offer.description}
                                            </Typography>
                                        </Grid>
                                        <Grid className="order-card__description__price" item sm={3} xs="auto">
                                            {offer.upFrontChargeAmount + offer.oneOffChargeAmount !== 0 && (
                                                <Fragment>
                                                    <Hidden smUp>
                                                        <Typography color="secondary" variant="body1">
                                                            {t("order:onceOffCharge")}
                                                        </Typography>
                                                    </Hidden>
                                                    <Typography align="right" color="primary" variant="h4">
                                                        {t("common:price", {
                                                            price: offer.upFrontChargeAmount + offer.oneOffChargeAmount,
                                                        })}
                                                    </Typography>
                                                </Fragment>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {offerList.length !== index + 1 && (
                                    <Grid className="order-card__divider" item xs={12}>
                                        <Divider variant="fullWidth" />
                                    </Grid>
                                )}
                            </Fragment>
                        ))}
                    </Fragment>
                )}
            </Grid>
        </div>
    );
};
